import { memo } from 'react';

import { Prose } from '@/components/ui/prose/prose';
import type { ColumnWidth } from '@/components/ui/table/columnWidth';
import { getByPath } from '@/utils/widgets';
import type { WidgetData } from '../../widget.type';
import type { TextView } from '../text/text.view.type';
import type { ProseView } from './prose.type';

type Props = {
  view: ProseView;
  data: WidgetData;
};

const ProseViewImpl = memo(({ view, data }: Props) => {
  const { path, small, light } = view;

  if (light) {
    console.warn('light is deprecated for prose view');
  }

  let proseData = getByPath<string | object>(data, path);
  if (!proseData) return null;

  if (typeof proseData === 'object') {
    proseData = JSON.stringify(proseData, null, 2);
  }

  return <Prose small={small} text={proseData} />;
});

// sort defaults to text on path
const getSortConfig = (view: ProseView): TextView => ({
  type: 'text',
  path: view.path
});

// filtering defaults to text search on path
const getFilterConfig = (view: ProseView): TextView => ({
  type: 'text',
  path: view.path
});

// width defaults to 'xlarge'
const getDefaultWidth = (): ColumnWidth => 'xlarge';

// stringifies data at path
const getStringifyFunction = (view: ProseView) => {
  const { path } = view;
  return (data: WidgetData) => {
    let proseData = getByPath<string | object>(data, path);
    if (!proseData) return '';

    if (typeof proseData === 'object') {
      proseData = JSON.stringify(proseData, null, 2);
    }
    return proseData;
  };
};

export const proseViewProvider = {
  component: ProseViewImpl,
  getSortConfig,
  getFilterConfig,
  getDefaultWidth,
  getStringifyFunction
};
